export const crumbs = [
  { name: 'Home', href: '/' },
  { name: 'API Docs', href: '/api' },
];
